import { KYDAdminEvent, KYDAdminEventDetail } from "@common/interfaces/KYDEvent";
import { useCallback, useEffect, useState } from "react";
import { useDialog } from "../../../Common/Dialog";
import { useLoading } from "../../hooks/form";
import actions from "../../../actions";

export const useKydEvent = (event_id?: string) => {
  const [kydEvent, setKydEvent] = useState<KYDAdminEventDetail | null>();
  const [loading, setLoading] = useLoading<{ init: boolean }>({
    init: false,
  });
  const dialog = useDialog();

  const fetchEvent = useCallback(
    async (eventId?: string, options?: any): Promise<KYDAdminEvent> => {
      if (!options || (options && !options.silent)) {
        setLoading("init", true);
      }

      let _;
      try {
        if (!eventId) {
          throw Error("NO event ID provided");
        }
        _ = await actions.ADMIN.fetchEventWithSections(eventId);
        setKydEvent(_);
      } catch (err) {
        dialog({ text: err.message });
      }
      setLoading("init", false);
      return _;
    },
    [setLoading, dialog]
  );

  useEffect(() => {
    if (event_id) {
      setLoading("init", true);

      fetchEvent(event_id).finally(() => {
        setLoading("init", false);
      });
    }
  }, [event_id, fetchEvent, setLoading]);

  return {
    refetch: (options?: any) => fetchEvent(event_id, options),
    kydEvent,
    loading: loading.init as boolean,
  };
};
